import CRUD from "@/firebase/crud";
import store from "@/store/index";

const report = {
    namespaced: true,
    state: {
        sponsorID: "",
        sponsorName: "",
        gameID: "",
        secondGameID: "",
        gameName: "",
        secondGameName: "",
        gameDate: "",
        secondGameDate: "",
        result: {}
    },
    mutations: {
        setValue(state, [name, data]){
            state[name] = data;
        },
        setReportData(state, data){
            state.result = data;
        }
    },
    actions: {
        sendReportData: async({commit}, payload) => {
            try{
                let sID = payload[0];
                let gID = payload[1];
                // console.log("Payload report: " + "sponsorID: " +sID + ", gameID:" + gID);
                store.commit("report/setReportData", [sID, gID]);
            } catch(err){
                // console.log(err);
            }
        },
        sendFirstGameIDandName: async({commit}, payload) => {
            try{
                let gID = payload[0];
                let gName = payload[1];
                // console.log("Payload report: " + "first game id: " + gID + "\ngame name: " + gName);
                store.commit("report/setReportData", [gID, gName]);

            }catch(err){
                // console.log(err);
            }
        },
        sendSecondGameIDandName: async({commit}, payload) => {
            try{
                let sgID = payload[0];
                let sgName = payload[1];
                // console.log("Payload report: " + "second game id: " + sgID + "\ngame name: " + sgName) ;
                store.commit("report/setReportData", sgID);
            }catch(err){
                // console.log(err);
            }
        }
    }
}

export default report;